import * as Sentry from "@sentry/react";

/**
 * Returns true if the error is a Supabase FunctionsHttpError with a 4xx status.
 * These are expected business logic failures (auth denied, validation, etc.)
 * that should NOT be reported to Sentry.
 */
export function isExpectedFunctionError(error: unknown): boolean {
  if (error && typeof error === "object" && "name" in error) {
    const e = error as { name: string; context?: { status?: number } };
    if (e.name === "FunctionsHttpError" && e.context?.status) {
      return e.context.status >= 400 && e.context.status < 500;
    }
  }
  return false;
}

export function reportError(
  error: unknown,
  feature: string,
  context?: Record<string, unknown>
): void {
  console.error(`[${feature}]`, error);

  const normalizedError =
    error instanceof Error
      ? error
      : new Error(
          typeof error === "object" && error !== null
            ? (error as { message?: string }).message || JSON.stringify(error)
            : String(error)
        );

  Sentry.withScope((scope) => {
    scope.setTag("feature", feature);
    scope.setFingerprint([feature, normalizedError.message]);
    if (context) {
      scope.setContext("extra", context);
    }
    Sentry.captureException(normalizedError);
  });
}
